//#region Old Code

// import React from "react";
// import { FIRMS } from "../../consts/tables";
// import FirmInfo from "./FirmInfo";
// import CRUD from "../CRUD";
// import { browserHistory } from "react-router";
// import { getData, manageData } from "../../requests/CRUD";

// export default class CRUDFirm extends React.Component {
//   constructor(props) {
//     super(props);

//     this.state = {
//       data: null,
//       original: null,
//       isBusy: null,
//       error: null,
//       success: null,
//       errorTabs: [],
//       currentTab: 0,
//       viewMode: this.props.edit || false,
//     };

//     this.handleSubmit = this.handleSubmit.bind(this);
//     this.handleChange = this.handleChange.bind(this);
//     this.saveData = this.saveData.bind(this);
//     this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
//   }

//   componentWillReceiveProps(nextProps) {
//     if (this.props.params.id !== nextProps.params.id) {
//       this.fetch(nextProps.params.id);
//     }
//   }

//   componentDidMount() {
//     this.fetch(this.props.params.id);
//   }

//   fetch(id) {
//     this.setState({
//       data: null,
//       error: null,
//       success: null,
//     });

//     if (id === undefined) {
//       this.setState({
//         data: {},
//       });
//       return;
//     }

//     getData({
//       tableCode: FIRMS,
//       options: {
//         filter: [
//           {
//             text: id,
//             code: "ARCIMEDES_ROW_ID",
//             type: "exact",
//           },
//         ],
//       },
//     }).then((res) => {
//       if (res && res.success && Array.isArray(res.data) && res.data.length) {
//         this.setState({
//           data: res.data[0],
//           original: { ...res.data[0] },
//           error: null,
//         });
//       } else {
//         this.setState({
//           data: false,
//           error: res.message ? res.message : "Unidentified Error",
//         });
//       }
//     });
//   }

//   handleSubmit(e) {
//     e.preventDefault();

//     if (this.state.viewMode) this.setState({ viewMode: false });

//     if (this.state.isBusy || this.state.viewMode === true) return;

//     this.setState({ viewMode: true }, () => this.saveData());
//   }

//   handleChange(key, value) {
//     this.setState({
//       data: Object.assign(this.state.data, {
//         [key]: value,
//       }),
//     });
//   }

//   handleChangeDropdown(query, queryType, x, key) {
//     this.setState({
//       data: Object.assign(this.state.data, {
//         [key]: query[key],
//       }),
//     });
//   }

//   saveData() {
//     if (this.state.isBusy) return;

//     this.setState({
//       isBusy: true,
//       error: null,
//       success: null,
//     });

//     Object.keys(this.state.data).forEach((k) => {
//       if (!this.state.data[k] || k === "undefined") {
//         const newData = { ...this.state.data };
//         delete newData[k];
//         this.setState({ data: newData });
//       }
//     });

//     return manageData({ tableCode: FIRMS, data: [this.state.data] }).then(
//       (res) => {
//         if (res && res.success) {
//           this.setState(
//             {
//               isBusy: false,
//               success: "Saved",
//             },
//             () => {
//               if (!this.props.edit) {
//                 browserHistory.push({
//                   pathname: `/firm/${res.data[0].ARCIMEDES_ROW_ID}`,
//                 });
//               }
//             }
//           );

//           window.scrollTo(0, 0);
//         } else {
//           this.setState({
//             isBusy: null,
//             error: res && res.message ? res.message : "Unspecified error",
//           });
//         }
//       }
//     );
//   }

//   render() {
//     const data = this.state.data;
//     const { edit, isSuper } = this.props;

//     return (
//       <CRUD
//         tabsData={[
//           {
//             name: "FIRM",
//             renderedComponent: (
//               <FirmInfo
//                 data={data}
//                 handleChangeInput={this.handleChange}
//                 handleChangeDropdown={this.handleChangeDropdown}
//                 viewMode={this.state.viewMode}
//                 deleted={data && data.DELETED === "1"}
//               />
//             ),
//           },
//         ]}
//         backLink={`${arc.path.base}firms`}
//         edit={edit}
//         state={this.state}
//         setState={this.setState.bind(this)}
//         handleSubmit={this.handleSubmit}
//         saveData={this.saveData}
//         type="firm"
//         backName="FIRMS"
//         title={data && `${data.NAME}`}
//         isSuper = {isSuper}
//       />
//     );
//   }
// }

//#endregion

import React from "react";
import FirmInfo from "./FirmInfo";
import CRUD from "../CRUD";
import { browserHistory } from "react-router";
import { ApolloConsumer } from "@apollo/client";
// import { CREATE_FIRMS } from "../Graphql/Mutations/FirmMutation";
// import { GET_FIRMS_BY_ID } from "../Graphql/Queries/FirmQuery";
import { fetchData, mutateData } from "../Service/graphQlService";
import { CREATE_OR_UPDATE_COMPANY_FIRM } from "../Graphql/CompanysMutations/allCompanysMutation";
import { GET_COMPANY_FIRM_BY_ID, GET_COMPANY_FIRM_QUERY } from "../Graphql/CompanyQueries/allCompanyQuery";
import filter from "../../filter";

export default class CRUDFirm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      original: null,
      isBusy: null,
      error: null,
      success: null,
      errorTabs: [],
      currentTab: 0,
      viewMode: this.props.edit || false,
      searchCrudFilter : false,
      filterData: [],
      currentIndex: 0,
      fromListUrl: props.location.state && props.location.state.fromListUrl || localStorage.getItem('fromListUrl') || null,
    };
    this.client = null;

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.saveData = this.saveData.bind(this);
    this.handleChangeDropdown = this.handleChangeDropdown.bind(this);
    this.updateURL = this.updateURL.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.fetch(nextProps.params.id);
    }
  }
  parseFilterOptions(query){
    const filterObject = {};
    if(query){
        for(const key in query){
            if(key !== 'order' && key !== 'page'){
                filterObject[key]= query[key]
            }
        }
    }
    return [filterObject]
}

//   componentDidMount() {debugger
//     const query = this.props.location.search;
// 		// const options = filter(query, 'firms');
// 		// options.param.limit = limit;
// 		// options.param.offset = query.page ? ((Number(query.page) - 1) * limit) : 0;

// 		// var pageParams = {
// 		// 	page: query.page ? Number(query.page) : 1,
// 		// 	pageSize: limit
// 		// }
// 		// const token = localStorage.getItem('authToken');
// 		// const sortOptions = this.parseSortOptions(q.order);
//         const filterOptions = this.parseFilterOptions(query); 
//     // const q = this.props.location.search;
//     // const nameFilter = queryParams.get('name');
//     // console.log('Name filter:', nameFilter); // Logs 'test' if ?name=test is present
    
//     if(!nameFilter){
//      this.fetch(this.props.params.id);
//     }
// else if( nameFilter){
//   this.fetch(nameFilter)
//   this.setState({
//     searchCrudFilter:true
//   })
// }
//   }
//   fetch(id) {
//     this.setState({
//       data: null,
//       error: null,
//       success: null,
//     });

//     if (id === undefined) {
//       this.setState({
//         data: {},
//       });
//       return;
//     }

   
//     const token = localStorage.getItem('authToken');
    
//   const Numberid = Number(id)
//   if(Numberid){
//     fetchData(GET_COMPANY_FIRM_BY_ID, { companyId : Number(id)})
//       .then((res) => {
        
//         if (res && res.data && res.data.getCompanyById.company) {
//           this.setState({
//             data:  res.data.getCompanyById.company,
//             original: { ...res.data.getCompanyById.company },
//             error: null,
//           });
//         } else {
//           this.setState({
//             data: false,
//             error: res.errors ? res.errors[0].message : "Unidentified Error",
//           });
//         }
//       })
//       .catch((error) => {
//         this.setState({
//           data: false,
//           error: error.message || "Unidentified Error",
//         });
//       });
//   }
//   else if(id){
//     fetchData(GET_COMPANY_FIRM_QUERY, { type:"Firm",filters:{name:id}})
//             .then(res => {
//               this.handleFilterData(res)
//             })
//             .catch((error) => {
//               this.setState({
//                 data: false,
//                 error: error.message || "Unidentified Error",
//               });
//             });
//   }

//   }
componentDidMount() {
  if (this.state.fromListUrl) {
    localStorage.setItem('fromListUrl', this.state.fromListUrl);
    this.setState({ fromListUrl: this.state.fromListUrl });
  }
  const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
  if(!hasQuery){
    this.fetch(this.props.params.id);
  }
  if(hasQuery){
    this.setState({ searchCrudFilter: true });
    this.handleQueryChange();
  }
 
}
componentDidUpdate(prevProps) {

  const hasQuery = new URLSearchParams(this.props.location.search).toString().length > 0;
  const prevHasQuery = new URLSearchParams(prevProps.location.search).toString().length > 0;
  if (hasQuery && prevProps.location.search !== this.props.location.search) {
    this.handleQueryChange();
    this.setState({ searchCrudFilter: true });
  }
  // Check if the query has changed
  // if (prevProps.location.search !== this.props.location.search) {
  //   this.handleQueryChange();
  // }
  if(!hasQuery && prevHasQuery){
    this.fetch(this.props.params.id);
    this.setState({ searchCrudFilter: false });
  }
}

handleQueryChange() {
  const query = this.props.location.query;
  const filterOptions = this.parseFilterOptions(query); 

  var isNoFilter = Object.keys(filterOptions).length === 0; 

  if (isNoFilter) {
    this.fetch(this.props.params.id);
  }
  else{
    this.fetchWithFilter(filterOptions)
  }
}

fetch(id) {
  this.setState({
     // data: null, we have comment this line to avoid loading symbol has ali dont want to be screen get change when value is null we was showing loader 
    error: null,
    success: null,
  });

  if (id === undefined) {
    this.setState({
      data: {},
    });
    return;
  }
  const token = localStorage.getItem('authToken');
  
  fetchData(GET_COMPANY_FIRM_BY_ID, { companyId : Number(id)})
    .then((res) => {
      
      if (res && res.data && res.data.getCompanyById.company) {
        this.setState({
          data:  res.data.getCompanyById.company,
          original: { ...res.data.getCompanyById.company },
          error: null,
        });
      } else {
        this.setState({
          data: false,
          error: res.errors ? res.errors[0].message : "Unidentified Error",
        });
      }
    })
    .catch((error) => {
      this.setState({
        data: false,
        error: error.message || "Unidentified Error",
      });
    });
}

fetchWithFilter(filterOptions) {
  this.setState({
    data: null,
    error: null,
    success: null,
  });

  fetchData(GET_COMPANY_FIRM_QUERY, { type:"Firm",filters:filterOptions})
				.then(res => {
          const filterData = res.data.getCompanies.data || [];
          if(filterData.length > 0){
            this.setState({
              // items: res.data.getCompanies.data,
              // totalCount: res.data.getCompanies.totalCount,
              // error: null,
              // isBusy: null,
              filterData,
              currentIndex:0,
              data:  filterData[0],
              original: { ...filterData[0] },
              error: null,
            },() => {
              this.updateURL(filterData[0]);
            });
          }else {
            this.setState({
              filterData: [],
              data: false,
              error: "No filtered data found. Please try again with different filters.",
            });
          }
				})
				.catch((error) => {
          this.setState({
            data: false,
            error: error.message || "Unidentified Error",
          });
        });
  
  // fetchData(GET_COMPANY_FIRM_BY_ID, { companyId : Number(id)})
  //   .then((res) => {
      
  //     if (res && res.data && res.data.getCompanyById.company) {
  //       this.setState({
  //         data:  res.data.getCompanyById.company,
  //         original: { ...res.data.getCompanyById.company },
  //         error: null,
  //       });
  //     } else {
  //       this.setState({
  //         data: false,
  //         error: res.errors ? res.errors[0].message : "Unidentified Error",
  //       });
  //     }
  //   })
    
}

updateURL(data) {
  const queryParams = new URLSearchParams(this.props.location.search);
  // const name = queryParams.get("name");
  // const newUrl = `/firm/${data.company_id}${name ? `?name=${name}` : ""}`;
  const newUrl = `/firm/${data.company_id}?${queryParams.toString()}`;
  browserHistory.push(newUrl);
}
  async handleSubmit(client, e) {
    e.preventDefault();

    if (this.state.viewMode) this.setState({ viewMode: false });

    if (this.state.isBusy || this.state.viewMode === true) return;

    this.setState({ viewMode: true }, () => this.saveData(client));
  }

  handleChange(key, value) {
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [key]: value
      }
    }));
  }

  handleChangeDropdown(query, queryType, x, key) {
    
    this.setState(prevState => ({
      data: {
        ...prevState.data,
        [key]: query[key]
      }
    }));
  }

  async saveData(client) {
    if (this.state.isBusy) return;

    this.setState({
      isBusy: true,
      error: null,
      success: null,
    });

    Object.keys(this.state.data).forEach((k) => {
      if (!this.state.data[k] || k === "undefined") {
        const newData = { ...this.state.data };
        delete newData[k];
        this.setState({ data: newData });
      }
    });

    var pageParams = {
      page: 1,
      pageSize: 50
    }

    try {
      // const variables = {
      //   arcimedes_row_id: this.props.params.id,
      //     name: this.state.data.name,
      //     address: this.state.data.address,
      //     city: this.state.data.city,
      //     state: this.state.data.state,
      //     zip: Number(this.state.data.zip),
      //     phone: this.state.data.phone,
      //     parent_firm: this.state.data.parent_firm,
      //     website: this.state.data.website,
      //     deleted: this.state.data.deleted
      // }
const input = {
  company_type:"Firm",
  // arcimedes_row_id: this.props.params.id ? this.props.params.id : "", 
  company_id : this.props.params.id ? this.props.params.id : null,
  name: this.state.data.name ? this.state.data.name : null ,
  address: this.state.data.address ? this.state.data.address : null,
  city: this.state.data.city ? this.state.data.city : null,
  state: this.state.data.state ? this.state.data.state : null,
  zip: this.state.data.zip ?  Number(this.state.data.zip): null,
  phone: this.state.data.phone ? this.state.data.phone : null,
  parent_firm: this.state.data.parent_firm ? this.state.data.parent_firm.toString() : null,
  website:  this.state.data.parent_firm ?  this.state.data.website : null,
  deleted: this.state.data.deleted ?  this.state.data.deleted : null,
} 
      // const token = localStorage.getItem('authToken');
      // const res = await client.mutate({
      //   mutation: CREATE_FIRMS,
      //   variables: {
      //     arcimedes_row_id: this.props.params.id,
      //     name: this.state.data.name,
      //     address: this.state.data.address,
      //     city: this.state.data.city,
      //     state: this.state.data.state,
      //     zip: Number(this.state.data.zip),
      //     phone: this.state.data.phone,
      //     parent_firm: this.state.data.parent_firm,
      //     website: this.state.data.website,
      //     deleted: this.state.data.deleted
      //   },
      //   context: {
      //     headers: {
      //         authorization: `Bearer ${token}`, // Bearer token added here
      //     },
      // },
      //   // refetchQueries: [{ query: GET_FIRMS, variables: { pageOptions: pageParams } }],
      // });
      // const res = await mutateData(CREATE_FIRMS, variables)
      // if (res && res.data) {
      //   this.setState({
      //     isBusy: false,
      //     success: "Saved",
      //   }, () => {
      //     if (!this.props.edit) {
      //       browserHistory.push({
      //         pathname: `/firm/${res.data.createOrUpdateFirm.firm.arcimedes_row_id}`,
      //       });
      //     }
      //   });

      //   window.scrollTo(0, 0);
      // }
      
      const res = await mutateData(CREATE_OR_UPDATE_COMPANY_FIRM,  {
        input :input
      },)
      if (res && res.data.createOrUpdateCompany.success) {
        this.setState({
          isBusy: false,
          success: "Saved",
        }, () => {
          if (!this.props.edit) {
            browserHistory.push({
              pathname: `/firm/${res.data.createOrUpdateCompany.company.company_id}`,
            });
          }
        });

        window.scrollTo(0, 0);
      }
      else if(res.data.createOrUpdateCompany.error){
        this.setState({
        isBusy: false,
        error: res.data.createOrUpdateCompany.message || "Unspecified error",
      });
      }
    } catch (error) {
      console.error("Error in saveData:", error);
      this.setState({
        isBusy: false,
        error: error.message || "Unspecified error",
      });
    }
  }

  render() {
    const data = this.state.data;
    const { edit, isSuper, location } = this.props;

    return (
      <ApolloConsumer>
        {client => {
          if (!this.client) this.client = client;
          return (
            <CRUD
              tabsData={[
                {
                  name: "Company",
                  renderedComponent: (
                    <FirmInfo
                      data={data}
                      handleChangeInput={this.handleChange}
                      handleChangeDropdown={this.handleChangeDropdown}
                      viewMode={this.state.viewMode}
                      deleted={data && data.deleted === 1}
                   
                    />
                  ),
                },
              ]}
              backLink={`${arc.path.base}company/firms`}
              edit={edit}
              state={this.state}
              setState={this.setState.bind(this)}
              handleSubmit={(e) => this.handleSubmit(client, e)}
              saveData={() => this.saveData(client)}
              type="Company"
              backName="Companies"
              title={data && `${data.name}`}
              isSuper={isSuper}
              filterData={this.state.filterData}
              currentIndex={this.state.currentIndex}
              updateURL={this.updateURL}
              // backToUrl={"firms"}
              backToUrl={this.state.fromListUrl ? this.state.fromListUrl : "/firms"}
            />
          )
        }}

      </ApolloConsumer>
    );
  }
}
